//Import required libraries
import React, { useState } from 'react';

//Import custom components
import Year from './Year'

//Import Styles
import './Content.scss';

//Import Data
import useFirestore from '../../../hooks/useFirestore';
import { store } from '../../../store/initialState'

//Import Utils
import { splitDocsToArr } from '../../../utils/utils'

let path = store.path

const Content = props => {

    let { catSelected } = props
    
    const [imageSelected, setImageSelected] = useState(null);    
    const { docs } = useFirestore(path);
    let yearArr;
    
    if (docs.length > 0) {
        yearArr = splitDocsToArr(docs, catSelected, catSelected === 'All') //Split by year only if category selected is All
    }

    return (
        <>
            <div className="content">
                {
                    yearArr && yearArr.map((obj, index) => {
                        return (
                            <Year key={index} {...obj} setImageSelected={setImageSelected} catSelected={catSelected} />
                        )
                    })
                }
            </div>
            {
                imageSelected 
                && 
                <div className='click-expanded-container'>
                    <i className="fa fa-arrow-circle-o-left" 
                        aria-hidden="true"
                        onClick={() => {setImageSelected(null)}}></i>
                    <img className='click-expanded' src={imageSelected.url}></img>
                </div>
            }
        </>
    )
}

export default Content